// extracted by mini-css-extract-plugin
export default {"gameplay_main":"GameplayCinematicReact_gameplay_main__xqv9s","continue_btn":"GameplayCinematicReact_continue_btn__IonX+","blink":"GameplayCinematicReact_blink__UXUGC"};